import React from 'react';
import { Grid, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrderPageTypography } from '../themedComponents/OrderPageTypography';
import { OrderPageToggleButton } from '../themedComponents/OrderPageToggleButton';
import { useLanguage } from '../../utils/GeneralUtils';
import { useOrderPage } from '../orderPageContext/useOrderPage';
import { asOrderPageData } from '../core/types';

const ResourceOptionSelector = () => {
  const { t } = useTranslation();
  const language = useLanguage();
  const { orderPageState, setOrderDetailValue } = useOrderPage();
  const resourceOptions = asOrderPageData(orderPageState.orderPage)?.resource_options;

  if (!resourceOptions || resourceOptions.length < 2) {
    return null;
  }

  const onValueChange = (event: React.MouseEvent<HTMLElement>, value: string | null) => {
    if (value != null) {
      setOrderDetailValue('resource_option_id', value);
    }
  };

  return (
    <Grid container direction="column">
      <Grid item>
        <OrderPageTypography variant="h3" bold>
          {t('uiObjects.chooseArea')}
        </OrderPageTypography>
      </Grid>
      <Grid item sx={{ mt: 2.5, mb: 2.5, cursor: 'pointer' }}>
        <ToggleButtonGroup
          orientation="vertical"
          sx={{
            width: '95%',
            display: 'grid',
            gridAutoRows: '1fr',
            '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
              marginTop: 0,
              borderTop: '1px solid',
              borderTopLeftRadius: 1,
              borderTopRightRadius: 1,
            },
            '& .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
              borderBottomLeftRadius: 1,
              borderBottomRightRadius: 1,
            },
          }}
          value={orderPageState.details.resource_option_id}
          color="primary"
          exclusive
          onChange={onValueChange}>
          {resourceOptions.map((resourceOption) => {
            const description = resourceOption.description?.[language];
            return (
              <OrderPageToggleButton
                key={resourceOption.id}
                sx={{ textTransform: 'none', cursor: 'pointer', width: '100%' }}
                value={resourceOption.id}
                disabled={orderPageState.isLoadingDates}>
                <Grid container direction="column" alignItems="flex-start">
                  {resourceOption.label[language]}
                  {description && (
                    <OrderPageTypography
                      variant="body2"
                      style={{ fontSize: '0.75rem', fontWeight: 300, opacity: 0.65 }}>
                      {description}
                    </OrderPageTypography>
                  )}
                </Grid>
              </OrderPageToggleButton>
            );
          })}
        </ToggleButtonGroup>
      </Grid>
    </Grid>
  );
};

export default ResourceOptionSelector;
